import { Component, Input, OnInit, Output, EventEmitter  } from '@angular/core';

@Component({
  selector: 'app-consulta-crlv-e',
  templateUrl: './consulta-crlv-e.component.html',
  styleUrls: ['./consulta-crlv-e.component.scss']
})
export class ConsultaCrlvEComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();
  @Input() erroUf = false;

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    if(this.erroUf)
      this.statusMsg = "ERRO_UF"
   }

}
